import React, { useEffect, useRef, useState } from "react";
import gsap from 'gsap';

// Imágenes para cinta
import cabeza from '../assets/loading/cabeza_01.png';
import cinta from '../assets/loading/cuerpo_02.png'
import txtCinta from '../assets/loading/letra_03.png';

import cargandoImagen from '../assets/loading/ETIQUETA_CARGANDO.webp';

/*const images = [
      cargandoImagen,
      cargandoImagen,
      cargandoImagen,
];*/



function Loading() {
  /*useEffect(() => {
    const cintaMove = document.getElementById("cinta-move");
    if (!cintaMove) return;
    
    const maskCintaImg = cintaMove.querySelector(".mask-cinta");
    const cintaImg = cintaMove.querySelector(" .cinta-roll");
        
    //matchMedia para separar desktop y mobile
    const mm = gsap.matchMedia();
    mm.add(
      {
        isDesktop: "(min-width: 992px)",
        isTablet: "(min-width: 768px) and (max-width: 991px)",
        isChTablet: "(min-width: 576px) and (max-width: 767px)",
        isMobile: "(max-width: 575px)",
      },
      (context) => {
        let { isDesktop, isTablet, isMobile, isChTablet } = context.conditions;

        if (maskCintaImg) {
          const tlImg = gsap.timeline({ repeat: -1, yoyo: false });

          if (isDesktop) {
            // --- Versión Desktop ---
            tlImg
              .to(maskCintaImg, { maskSize: "23% 100%", duration: 1, ease: "power2.out" })
              .to(maskCintaImg, { maskSize: "35% 100%", duration: 2, ease: "power2.out" })
              .to(maskCintaImg, { maskSize: "50% 100%", duration: 2, ease: "power2.out" })
              .to(maskCintaImg, { maskSize: "100% 100%", duration: 2, ease: "power2.out" });
          }
          if(isTablet){
             // --- Versión Desktop ---
            tlImg
              .to(maskCintaImg, { maskSize: "23% 100%", duration: 1, ease: "power2.out" })
              .to(maskCintaImg, { maskSize: "35% 100%", duration: 2, ease: "power2.out" })
              .to(maskCintaImg, { maskSize: "50% 100%", duration: 2, ease: "power2.out" })
              .to(maskCintaImg, { maskSize: "100% 100%", duration: 2, ease: "power2.out" });
          }
          if(isChTablet){
             // --- Versión Desktop ---
            tlImg
              .to(maskCintaImg, { maskSize: "23% 100%", duration: 1, ease: "power2.out" })
              .to(maskCintaImg, { maskSize: "35% 100%", duration: 2, ease: "power2.out" })
              .to(maskCintaImg, { maskSize: "50% 100%", duration: 2, ease: "power2.out" })
              .to(maskCintaImg, { maskSize: "100% 100%", duration: 2, ease: "power2.out" });
          }
          if (isMobile) {
            // --- Versión Mobile (más rápida y menos distancia) ---
            tlImg
              .to(maskCintaImg, { maskSize: "25% 100%", duration: 1, ease: "power1.out" })
              .to(maskCintaImg, { maskSize: "55% 100%", duration: 2, ease: "power1.out" })
              .to(maskCintaImg, { maskSize: "80% 100%", duration: 2, ease: "power2.out" })
              .to(maskCintaImg, { maskSize: "100% 100%", duration: 2, ease: "power1.out" });
          }
        }

        if (cintaImg) {
          const tlRibbon = gsap.timeline({ repeat: -1, yoyo: false });

          if (isDesktop) {
            tlRibbon
              .to(cintaImg, { x: 0, y: 0, duration: 1, ease: "power2.out" })
              .to(cintaImg, { x: 80, y: -43, duration: 2, ease: "power2.out" })
              .to(cintaImg, { x: 190, y: -100, duration: 2, ease: "power2.out" })
              .to(cintaImg, { x: 320, y: -170, duration: 2, ease: "power2.out" });
          }
          if (isTablet) {
            tlRibbon
              .to(cintaImg, { x: 0, y: 0, duration: 1, ease: "power2.out" })
              .to(cintaImg, { x: 80, y: -43, duration: 2, ease: "power2.out" })
              .to(cintaImg, { x: 150, y: -83, duration: 2, ease: "power2.out" })
              .to(cintaImg, { x: 250, y: -135, duration: 2, ease: "power2.out" });
          }
          if (isChTablet) {
            tlRibbon
              .to(cintaImg, { x: 0, y: 0, duration: 1, ease: "power2.out" })
              .to(cintaImg, { x: 80, y: -43, duration: 2, ease: "power2.out" })
              .to(cintaImg, { x: 150, y: -83, duration: 2, ease: "power2.out" })
              .to(cintaImg, { x: 250, y: -135, duration: 2, ease: "power2.out" });
          }
          if (isMobile) {
            tlRibbon
              .to(cintaImg, { x: 0, y: 5, duration: 1, ease: "power1.out" })
              .to(cintaImg, { x: 60, y: -25, duration: 2, ease: "power1.out" })
              .to(cintaImg, { x: 90, y: -45, duration: 2, ease: "power2.out" })
              .to(cintaImg, { x: 103, y: -50, duration: 2, ease: "power1.out" });
          }
        }
      }
    );
    return () => mm.revert(); // limpia animaciones al desmontar
    }, []);*/


        /*if (maskCintaImg) {
          const tlImg = gsap.timeline({ repeat: -1, yoyo: false });
          tlImg
            .to(maskCintaImg, {
              x: 0,
              y: 0,
              duration: 1,
              maskSize: '23% 100%',
              delay: 0,
              ease: "power2.out",
            })
            .to(maskCintaImg, {
              x: 0,
              y: 0,
              duration: 2,
              maskSize: '35% 100%',
              ease: "power2.out",
            })
            .to(maskCintaImg, {
              x: 0,
              y: 0,
              duration: 2,
              maskSize: '50% 100%',
              ease: "power2.out",
            })
            .to(maskCintaImg, {
              x: 0,
              y: 0,
              duration: 2,
              maskSize: '100% 100%',
              ease: "power2.out",
            })
            ;
        }
    
        const tlRibbon = gsap.timeline({ repeat: -1, yoyo: false });
        tlRibbon
        .to(cintaImg, {
            x: 0,        // derecha
            y: 0,        // hacia arriba (negativo en coordenadas CSS)
            duration: 1,
            delay: 0,
            ease: "power2.out",
        })
        .to(cintaImg, {
            x: 80,
            y: -43,
            duration: 2,
            ease: "power2.out",
        })
        .to(cintaImg, {
            x: 190,
            y: -100,
            duration: 2,
            ease: "power2.out",
        })
        .to(cintaImg, {
            x: 320,
            y: -170,
            duration: 2,
            ease: "power2.out",
        });
    }, []);*/

    
    /*const [position, setPosition] = useState(0);
    const trackRef = useRef(null);

    // Ancho de cada imagen (lo usaremos para calcular el avance de "media imagen")
    const IMAGE_WIDTH = 300; // px (ajusta según tus imágenes o con getBoundingClientRect)
    const STEP = IMAGE_WIDTH / 2; //  media imagen

    useEffect(() => {
      const interval = setInterval(() => {
        setPosition((prev) => {
          if (Math.abs(prev) >= images.length * IMAGE_WIDTH) {
            return 0; // reset aquí
          }
          return prev - STEP;
        });
      }, 3000);

      return () => clearInterval(interval);
    }, []);*/
    useEffect(() => {
          const carouselElement = document.querySelector('#loadingCarousel');
    
          if (carouselElement) {
            const carousel = new window.bootstrap.Carousel(carouselElement, {
              interval: 1000,
              ride: 'carousel',
              pause: false,
              wrap: true
            });
          }
        }, []);
        /*
      position:'absolute', left:'50%', top:'50%', transform:'translate(-50%,-50%) scale(1.5)', width:'360px', height:'445px', zIndex:'10'*/
      /*<div id="cont-cinta" className="wrap">
        
        <div id="cinta-move" >
          <img src={cabeza} className='cinta-roll'  alt="Vaso top" />
          <div className="mask-cinta">
            <img src={txtCinta} className='txt-cinta'  alt="texto-cinta"/>
            <img src={cinta} className='cinta'  alt="cinta con texto"/>
          </div>
        </div>
      </div>*/
      /*<div className="carousel-cinta">
      <div
        className="carousel-track"
        ref={trackRef}
        style={{
          transform: `translateX(${position}px)`,
          transition: "transform 0.8s ease",
        }}
        onTransitionEnd={() => {
          // Resetear para loop infinito
          if (Math.abs(position) >= images.length * IMAGE_WIDTH) {
            setPosition(0);
          }
        }}
      >
        
        {[...images, ...images].map((img, idx) => (
          <div className="carousel-item" key={idx}>
            <img src={img} alt={`Slide ${idx}`} />
          </div>
        ))}
      </div>
    </div>*/

  return (
    <div style={{width:'100%', display:'flex', justifyContent: 'center'}}>
    <div id="loadingCarousel" className="carousel slide" data-bs-ride="carousel">
      <div className="carousel-inner">
        <div className="carousel-item active">
          <div className="container-fluid">
            <div className='row'>
              <div className='col-4'>
                <img src={cargandoImagen} className="d-block w-100" alt="Cargando Test" />
              </div>
              <div className='col-4'>
                <img src={cargandoImagen} className="d-block w-100" alt="Cargando Test" />
              </div>
              <div className='col-4'>
                <img src={cargandoImagen} className="d-block w-100" alt="Cargando Test" />
              </div>
            </div>
          </div>
        </div>
        <div className="carousel-item">
          <div className="container-fluid">
            <div className='row'>
              <div className='col-4'>
                <img src={cargandoImagen} className="d-block w-100" alt="Cargando Test" />
              </div>
              <div className='col-4'>
                <img src={cargandoImagen} className="d-block w-100" alt="Cargando Test" />
              </div>
              <div className='col-4'>
                <img src={cargandoImagen} className="d-block w-100" alt="Cargando Test" />
              </div>
            </div>
          </div>
        </div>
        <div className="carousel-item  ">
          <div className="container-fluid">
            <div className='row'>
              <div className='col-4'>
                <img src={cargandoImagen} className="d-block w-100" alt="Cargando Test" />
              </div>
              <div className='col-4'>
                <img src={cargandoImagen} className="d-block w-100" alt="Cargando Test" />
              </div>
              <div className='col-4'>
                <img src={cargandoImagen} className="d-block w-100" alt="Cargando Test" />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*<button className="carousel-control-prev" type="button" data-bs-target="#loadingCarousel" data-bs-slide="prev">
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>
      <button className="carousel-control-next" type="button" data-bs-target="#loadingCarousel" data-bs-slide="next">
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button>*/}
    </div>
    </div>
  );
};

export default Loading